(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(".ys-navigation{height:var(--nd-total-header-height, 68px)}.ys-footer{margin-top:48px}")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import V, { useState as Cr, useEffect as U } from "react";
import { footerContent as ve } from "./assets/footer-content.js";
import { headerContent as ge } from "./assets/header-content.js";
var fe = { exports: {} }, L = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var se, Me;
function qe() {
  if (Me)
    return se;
  Me = 1;
  var t = Object.getOwnPropertySymbols, a = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
  function h(l) {
    if (l == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(l);
  }
  function g() {
    try {
      if (!Object.assign)
        return !1;
      var l = new String("abc");
      if (l[5] = "de", Object.getOwnPropertyNames(l)[0] === "5")
        return !1;
      for (var u = {}, d = 0; d < 10; d++)
        u["_" + String.fromCharCode(d)] = d;
      var v = Object.getOwnPropertyNames(u).map(function(s) {
        return u[s];
      });
      if (v.join("") !== "0123456789")
        return !1;
      var m = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(s) {
        m[s] = s;
      }), Object.keys(Object.assign({}, m)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return se = g() ? Object.assign : function(l, u) {
    for (var d, v = h(l), m, s = 1; s < arguments.length; s++) {
      d = Object(arguments[s]);
      for (var y in d)
        a.call(d, y) && (v[y] = d[y]);
      if (t) {
        m = t(d);
        for (var E = 0; E < m.length; E++)
          i.call(d, m[E]) && (v[m[E]] = d[m[E]]);
      }
    }
    return v;
  }, se;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Be;
function jr() {
  if (Be)
    return L;
  Be = 1, qe();
  var t = V, a = 60103;
  if (L.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var i = Symbol.for;
    a = i("react.element"), L.Fragment = i("react.fragment");
  }
  var h = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, g = Object.prototype.hasOwnProperty, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(d, v, m) {
    var s, y = {}, E = null, b = null;
    m !== void 0 && (E = "" + m), v.key !== void 0 && (E = "" + v.key), v.ref !== void 0 && (b = v.ref);
    for (s in v)
      g.call(v, s) && !l.hasOwnProperty(s) && (y[s] = v[s]);
    if (d && d.defaultProps)
      for (s in v = d.defaultProps, v)
        y[s] === void 0 && (y[s] = v[s]);
    return { $$typeof: a, type: d, key: E, ref: b, props: y, _owner: h.current };
  }
  return L.jsx = u, L.jsxs = u, L;
}
var ue = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ke;
function xr() {
  return Ke || (Ke = 1, function(t) {
    process.env.NODE_ENV !== "production" && function() {
      var a = V, i = qe(), h = 60103, g = 60106;
      t.Fragment = 60107;
      var l = 60108, u = 60114, d = 60109, v = 60110, m = 60112, s = 60113, y = 60120, E = 60115, b = 60116, D = 60121, Y = 60122, S = 60117, A = 60129, me = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var O = Symbol.for;
        h = O("react.element"), g = O("react.portal"), t.Fragment = O("react.fragment"), l = O("react.strict_mode"), u = O("react.profiler"), d = O("react.provider"), v = O("react.context"), m = O("react.forward_ref"), s = O("react.suspense"), y = O("react.suspense_list"), E = O("react.memo"), b = O("react.lazy"), D = O("react.block"), Y = O("react.server.block"), S = O("react.fundamental"), O("react.scope"), O("react.opaque.id"), A = O("react.debug_trace_mode"), O("react.offscreen"), me = O("react.legacy_hidden");
      }
      var Re = typeof Symbol == "function" && Symbol.iterator, Ze = "@@iterator";
      function Qe(e) {
        if (e === null || typeof e != "object")
          return null;
        var r = Re && e[Re] || e[Ze];
        return typeof r == "function" ? r : null;
      }
      var k = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function j(e) {
        {
          for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
            n[o - 1] = arguments[o];
          er("error", e, n);
        }
      }
      function er(e, r, n) {
        {
          var o = k.ReactDebugCurrentFrame, p = o.getStackAddendum();
          p !== "" && (r += "%s", n = n.concat([p]));
          var _ = n.map(function(f) {
            return "" + f;
          });
          _.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, _);
        }
      }
      var rr = !1;
      function tr(e) {
        return !!(typeof e == "string" || typeof e == "function" || e === t.Fragment || e === u || e === A || e === l || e === s || e === y || e === me || rr || typeof e == "object" && e !== null && (e.$$typeof === b || e.$$typeof === E || e.$$typeof === d || e.$$typeof === v || e.$$typeof === m || e.$$typeof === S || e.$$typeof === D || e[0] === Y));
      }
      function nr(e, r, n) {
        var o = r.displayName || r.name || "";
        return e.displayName || (o !== "" ? n + "(" + o + ")" : n);
      }
      function Oe(e) {
        return e.displayName || "Context";
      }
      function x(e) {
        if (e == null)
          return null;
        if (typeof e.tag == "number" && j("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof e == "function")
          return e.displayName || e.name || null;
        if (typeof e == "string")
          return e;
        switch (e) {
          case t.Fragment:
            return "Fragment";
          case g:
            return "Portal";
          case u:
            return "Profiler";
          case l:
            return "StrictMode";
          case s:
            return "Suspense";
          case y:
            return "SuspenseList";
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case v:
              var r = e;
              return Oe(r) + ".Consumer";
            case d:
              var n = e;
              return Oe(n._context) + ".Provider";
            case m:
              return nr(e, e.render, "ForwardRef");
            case E:
              return x(e.type);
            case D:
              return x(e._render);
            case b: {
              var o = e, p = o._payload, _ = o._init;
              try {
                return x(_(p));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var F = 0, we, ye, be, Ce, je, xe, Se;
      function Pe() {
      }
      Pe.__reactDisabledLog = !0;
      function ar() {
        {
          if (F === 0) {
            we = console.log, ye = console.info, be = console.warn, Ce = console.error, je = console.group, xe = console.groupCollapsed, Se = console.groupEnd;
            var e = {
              configurable: !0,
              enumerable: !0,
              value: Pe,
              writable: !0
            };
            Object.defineProperties(console, {
              info: e,
              log: e,
              warn: e,
              error: e,
              group: e,
              groupCollapsed: e,
              groupEnd: e
            });
          }
          F++;
        }
      }
      function or() {
        {
          if (F--, F === 0) {
            var e = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: i({}, e, {
                value: we
              }),
              info: i({}, e, {
                value: ye
              }),
              warn: i({}, e, {
                value: be
              }),
              error: i({}, e, {
                value: Ce
              }),
              group: i({}, e, {
                value: je
              }),
              groupCollapsed: i({}, e, {
                value: xe
              }),
              groupEnd: i({}, e, {
                value: Se
              })
            });
          }
          F < 0 && j("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Q = k.ReactCurrentDispatcher, ee;
      function K(e, r, n) {
        {
          if (ee === void 0)
            try {
              throw Error();
            } catch (p) {
              var o = p.stack.trim().match(/\n( *(at )?)/);
              ee = o && o[1] || "";
            }
          return `
` + ee + e;
        }
      }
      var re = !1, q;
      {
        var ir = typeof WeakMap == "function" ? WeakMap : Map;
        q = new ir();
      }
      function Te(e, r) {
        if (!e || re)
          return "";
        {
          var n = q.get(e);
          if (n !== void 0)
            return n;
        }
        var o;
        re = !0;
        var p = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var _;
        _ = Q.current, Q.current = null, ar();
        try {
          if (r) {
            var f = function() {
              throw Error();
            };
            if (Object.defineProperty(f.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(f, []);
              } catch (T) {
                o = T;
              }
              Reflect.construct(e, [], f);
            } else {
              try {
                f.call();
              } catch (T) {
                o = T;
              }
              e.call(f.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (T) {
              o = T;
            }
            e();
          }
        } catch (T) {
          if (T && o && typeof T.stack == "string") {
            for (var c = T.stack.split(`
`), C = o.stack.split(`
`), R = c.length - 1, w = C.length - 1; R >= 1 && w >= 0 && c[R] !== C[w]; )
              w--;
            for (; R >= 1 && w >= 0; R--, w--)
              if (c[R] !== C[w]) {
                if (R !== 1 || w !== 1)
                  do
                    if (R--, w--, w < 0 || c[R] !== C[w]) {
                      var P = `
` + c[R].replace(" at new ", " at ");
                      return typeof e == "function" && q.set(e, P), P;
                    }
                  while (R >= 1 && w >= 0);
                break;
              }
          }
        } finally {
          re = !1, Q.current = _, or(), Error.prepareStackTrace = p;
        }
        var $ = e ? e.displayName || e.name : "", Ve = $ ? K($) : "";
        return typeof e == "function" && q.set(e, Ve), Ve;
      }
      function Ie(e, r, n) {
        return Te(e, !1);
      }
      function sr(e) {
        var r = e.prototype;
        return !!(r && r.isReactComponent);
      }
      function G(e, r, n) {
        if (e == null)
          return "";
        if (typeof e == "function")
          return Te(e, sr(e));
        if (typeof e == "string")
          return K(e);
        switch (e) {
          case s:
            return K("Suspense");
          case y:
            return K("SuspenseList");
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case m:
              return Ie(e.render);
            case E:
              return G(e.type, r, n);
            case D:
              return Ie(e._render);
            case b: {
              var o = e, p = o._payload, _ = o._init;
              try {
                return G(_(p), r, n);
              } catch {
              }
            }
          }
        return "";
      }
      var De = {}, Ae = k.ReactDebugCurrentFrame;
      function J(e) {
        if (e) {
          var r = e._owner, n = G(e.type, e._source, r ? r.type : null);
          Ae.setExtraStackFrame(n);
        } else
          Ae.setExtraStackFrame(null);
      }
      function ur(e, r, n, o, p) {
        {
          var _ = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var f in e)
            if (_(e, f)) {
              var c = void 0;
              try {
                if (typeof e[f] != "function") {
                  var C = Error((o || "React class") + ": " + n + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw C.name = "Invariant Violation", C;
                }
                c = e[f](r, f, o, n, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (R) {
                c = R;
              }
              c && !(c instanceof Error) && (J(p), j("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", o || "React class", n, f, typeof c), J(null)), c instanceof Error && !(c.message in De) && (De[c.message] = !0, J(p), j("Failed %s type: %s", n, c.message), J(null));
            }
        }
      }
      var W = k.ReactCurrentOwner, te = Object.prototype.hasOwnProperty, cr = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, ke, Ne, ne;
      ne = {};
      function fr(e) {
        if (te.call(e, "ref")) {
          var r = Object.getOwnPropertyDescriptor(e, "ref").get;
          if (r && r.isReactWarning)
            return !1;
        }
        return e.ref !== void 0;
      }
      function lr(e) {
        if (te.call(e, "key")) {
          var r = Object.getOwnPropertyDescriptor(e, "key").get;
          if (r && r.isReactWarning)
            return !1;
        }
        return e.key !== void 0;
      }
      function dr(e, r) {
        if (typeof e.ref == "string" && W.current && r && W.current.stateNode !== r) {
          var n = x(W.current.type);
          ne[n] || (j('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', x(W.current.type), e.ref), ne[n] = !0);
        }
      }
      function vr(e, r) {
        {
          var n = function() {
            ke || (ke = !0, j("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
          };
          n.isReactWarning = !0, Object.defineProperty(e, "key", {
            get: n,
            configurable: !0
          });
        }
      }
      function gr(e, r) {
        {
          var n = function() {
            Ne || (Ne = !0, j("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
          };
          n.isReactWarning = !0, Object.defineProperty(e, "ref", {
            get: n,
            configurable: !0
          });
        }
      }
      var hr = function(e, r, n, o, p, _, f) {
        var c = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: h,
          // Built-in properties that belong on the element
          type: e,
          key: r,
          ref: n,
          props: f,
          // Record the component responsible for creating this element.
          _owner: _
        };
        return c._store = {}, Object.defineProperty(c._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(c, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: o
        }), Object.defineProperty(c, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: p
        }), Object.freeze && (Object.freeze(c.props), Object.freeze(c)), c;
      };
      function pr(e, r, n, o, p) {
        {
          var _, f = {}, c = null, C = null;
          n !== void 0 && (c = "" + n), lr(r) && (c = "" + r.key), fr(r) && (C = r.ref, dr(r, p));
          for (_ in r)
            te.call(r, _) && !cr.hasOwnProperty(_) && (f[_] = r[_]);
          if (e && e.defaultProps) {
            var R = e.defaultProps;
            for (_ in R)
              f[_] === void 0 && (f[_] = R[_]);
          }
          if (c || C) {
            var w = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
            c && vr(f, w), C && gr(f, w);
          }
          return hr(e, c, C, p, o, W.current, f);
        }
      }
      var ae = k.ReactCurrentOwner, $e = k.ReactDebugCurrentFrame;
      function N(e) {
        if (e) {
          var r = e._owner, n = G(e.type, e._source, r ? r.type : null);
          $e.setExtraStackFrame(n);
        } else
          $e.setExtraStackFrame(null);
      }
      var oe;
      oe = !1;
      function ie(e) {
        return typeof e == "object" && e !== null && e.$$typeof === h;
      }
      function Le() {
        {
          if (ae.current) {
            var e = x(ae.current.type);
            if (e)
              return `

Check the render method of \`` + e + "`.";
          }
          return "";
        }
      }
      function _r(e) {
        {
          if (e !== void 0) {
            var r = e.fileName.replace(/^.*[\\\/]/, ""), n = e.lineNumber;
            return `

Check your code at ` + r + ":" + n + ".";
          }
          return "";
        }
      }
      var Ue = {};
      function Er(e) {
        {
          var r = Le();
          if (!r) {
            var n = typeof e == "string" ? e : e.displayName || e.name;
            n && (r = `

Check the top-level render call using <` + n + ">.");
          }
          return r;
        }
      }
      function Ye(e, r) {
        {
          if (!e._store || e._store.validated || e.key != null)
            return;
          e._store.validated = !0;
          var n = Er(r);
          if (Ue[n])
            return;
          Ue[n] = !0;
          var o = "";
          e && e._owner && e._owner !== ae.current && (o = " It was passed a child from " + x(e._owner.type) + "."), N(e), j('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', n, o), N(null);
        }
      }
      function Fe(e, r) {
        {
          if (typeof e != "object")
            return;
          if (Array.isArray(e))
            for (var n = 0; n < e.length; n++) {
              var o = e[n];
              ie(o) && Ye(o, r);
            }
          else if (ie(e))
            e._store && (e._store.validated = !0);
          else if (e) {
            var p = Qe(e);
            if (typeof p == "function" && p !== e.entries)
              for (var _ = p.call(e), f; !(f = _.next()).done; )
                ie(f.value) && Ye(f.value, r);
          }
        }
      }
      function mr(e) {
        {
          var r = e.type;
          if (r == null || typeof r == "string")
            return;
          var n;
          if (typeof r == "function")
            n = r.propTypes;
          else if (typeof r == "object" && (r.$$typeof === m || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          r.$$typeof === E))
            n = r.propTypes;
          else
            return;
          if (n) {
            var o = x(r);
            ur(n, e.props, "prop", o, e);
          } else if (r.PropTypes !== void 0 && !oe) {
            oe = !0;
            var p = x(r);
            j("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", p || "Unknown");
          }
          typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && j("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Rr(e) {
        {
          for (var r = Object.keys(e.props), n = 0; n < r.length; n++) {
            var o = r[n];
            if (o !== "children" && o !== "key") {
              N(e), j("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", o), N(null);
              break;
            }
          }
          e.ref !== null && (N(e), j("Invalid attribute `ref` supplied to `React.Fragment`."), N(null));
        }
      }
      function We(e, r, n, o, p, _) {
        {
          var f = tr(e);
          if (!f) {
            var c = "";
            (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (c += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var C = _r(p);
            C ? c += C : c += Le();
            var R;
            e === null ? R = "null" : Array.isArray(e) ? R = "array" : e !== void 0 && e.$$typeof === h ? (R = "<" + (x(e.type) || "Unknown") + " />", c = " Did you accidentally export a JSX literal instead of a component?") : R = typeof e, j("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", R, c);
          }
          var w = pr(e, r, n, p, _);
          if (w == null)
            return w;
          if (f) {
            var P = r.children;
            if (P !== void 0)
              if (o)
                if (Array.isArray(P)) {
                  for (var $ = 0; $ < P.length; $++)
                    Fe(P[$], e);
                  Object.freeze && Object.freeze(P);
                } else
                  j("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Fe(P, e);
          }
          return e === t.Fragment ? Rr(w) : mr(w), w;
        }
      }
      function Or(e, r, n) {
        return We(e, r, n, !0);
      }
      function wr(e, r, n) {
        return We(e, r, n, !1);
      }
      var yr = wr, br = Or;
      t.jsx = yr, t.jsxs = br;
    }();
  }(ue)), ue;
}
process.env.NODE_ENV === "production" ? fe.exports = jr() : fe.exports = xr();
var I = fe.exports;
function Ge(t) {
  if (!t)
    return;
  const a = /<script\b[^>]*>([\s\S]*?)<\/script>/g, i = t.match(a) || [];
  let h = "";
  for (const l of i) {
    const u = l.replace(/<script\b[^>]*>|<\/script>/g, "");
    h += `try{${u}}catch(e){console.log(e)}
`;
  }
  const g = new Function(h);
  try {
    g();
  } catch (l) {
    console.log(l);
  }
}
async function Je(t, a) {
  const i = await fetch(t);
  if (a.returnType === "json")
    return await (i == null ? void 0 : i.json()) || void 0;
  if (a.returnType === "text")
    return await (i == null ? void 0 : i.text()) || void 0;
  throw new Error("Invalid returnType");
}
/*! js-cookie v3.0.5 | MIT */
function H(t) {
  for (var a = 1; a < arguments.length; a++) {
    var i = arguments[a];
    for (var h in i)
      t[h] = i[h];
  }
  return t;
}
var Sr = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function le(t, a) {
  function i(g, l, u) {
    if (!(typeof document > "u")) {
      u = H({}, a, u), typeof u.expires == "number" && (u.expires = new Date(Date.now() + u.expires * 864e5)), u.expires && (u.expires = u.expires.toUTCString()), g = encodeURIComponent(g).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var d = "";
      for (var v in u)
        u[v] && (d += "; " + v, u[v] !== !0 && (d += "=" + u[v].split(";")[0]));
      return document.cookie = g + "=" + t.write(l, g) + d;
    }
  }
  function h(g) {
    if (!(typeof document > "u" || arguments.length && !g)) {
      for (var l = document.cookie ? document.cookie.split("; ") : [], u = {}, d = 0; d < l.length; d++) {
        var v = l[d].split("="), m = v.slice(1).join("=");
        try {
          var s = decodeURIComponent(v[0]);
          if (u[s] = t.read(m, s), g === s)
            break;
        } catch {
        }
      }
      return g ? u[g] : u;
    }
  }
  return Object.create(
    {
      set: i,
      get: h,
      remove: function(g, l) {
        i(
          g,
          "",
          H({}, l, {
            expires: -1
          })
        );
      },
      withAttributes: function(g) {
        return le(this.converter, H({}, this.attributes, g));
      },
      withConverter: function(g) {
        return le(H({}, this.converter, g), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(a) },
      converter: { value: Object.freeze(t) }
    }
  );
}
var de = le(Sr, { path: "/" });
const He = () => {
  try {
    const t = "__storage_test__";
    return localStorage.setItem(t, t), localStorage.getItem(t), localStorage.removeItem(t), !0;
  } catch {
    return !1;
  }
}, ce = (t) => {
  if (!He())
    return null;
  const a = localStorage.getItem(t);
  return a ? JSON.parse(a) : null;
}, z = (t, a) => {
  He() && localStorage.setItem(t, JSON.stringify(a));
}, he = "nav-header", pe = "nav-footer", _e = "nav-date", Ee = "nav-sub";
let M, B;
const X = /* @__PURE__ */ new Date(), ze = new Date(
  Date.UTC(X.getFullYear(), X.getMonth(), X.getDate(), X.getHours())
).toISOString(), Z = (t, a) => {
  t === "header" ? M = a : t === "footer" && (B = a);
}, Pr = (t) => {
  if (t === "header")
    return M;
  if (t === "footer")
    return B;
}, Lr = async (t, a) => {
  try {
    const i = await Je(
      `https://yousee.dk/shop/api/navigation/${t}${a ? `?loggedIn=${a.loggedIn}&firstName=${a.firstName}&lastName=${a.lastName}` : ""}`,
      {
        returnType: "text"
      }
    );
    Z(t, i);
  } catch {
    Z(t, t === "header" ? ge : ve);
  }
  return Pr(t);
}, Xe = async (t, a) => {
  if (t === "header" && M)
    return M;
  if (t === "footer" && B)
    return B;
  const h = ce(t === "header" ? he : pe);
  return h && ce(_e) === ze && (t === "header" && ce(Ee) === (a == null ? void 0 : a.firstName) || t === "footer") ? (Z(t, h), h) : Tr(t, a).catch(() => t === "header" ? ge : ve);
}, Tr = (t, a) => Je(
  `https://yousee.dk/shop/api/navigation/${t}${a ? `?loggedIn=${a.loggedIn}&firstName=${a.firstName}&lastName=${a.lastName}` : ""}`,
  {
    returnType: "text"
  }
).then((i) => i ? (Z(t, i), t === "header" ? (z(he, M), z(Ee, (a == null ? void 0 : a.firstName) || "annon")) : t === "footer" && z(pe, B), z(_e, ze), i) : Promise.reject()), Ir = () => {
  de.remove("access_token", { domain: "yousee.dk" }), localStorage.removeItem(he), localStorage.removeItem(pe), localStorage.removeItem(_e), localStorage.removeItem(Ee);
};
const Ur = ({ className: t = "", content: a = void 0 }) => {
  const [i, h] = Cr(a);
  return U(() => {
    async function g() {
      try {
        const l = await Xe("footer");
        h(l);
      } catch {
        h(a || ve);
      }
    }
    g();
  }, [a]), U(() => {
    i && Ge(i);
  }, [i]), /* @__PURE__ */ I.jsx(I.Fragment, { children: i && /* @__PURE__ */ I.jsx("div", { className: `ys-footer ${t}`, dangerouslySetInnerHTML: { __html: i } }) });
}, Dr = (t) => {
  try {
    return JSON.parse(window.atob(t.split(".")[1]));
  } catch {
    return null;
  }
}, Ar = ({
  className: t = "",
  content: a = void 0,
  callback: i,
  params: h,
  hideBasketIcon: g,
  env: l = "prod"
}) => {
  const [u, d] = V.useState(a), [v, m] = V.useState(!1), [s, y] = V.useState();
  return U(() => {
    if (h)
      y(h);
    else {
      const E = de.get("access_token") || de.get("ACCESS_TOKEN"), b = E && Dr(E);
      y(b ? {
        loggedIn: !0,
        firstName: (b == null ? void 0 : b.sub) ?? "User",
        lastName: ""
      } : {
        loggedIn: !1
      });
    }
  }, [h]), U(() => {
    async function E() {
      try {
        const b = await Xe("header", s);
        d(b);
      } catch {
        d(a || ge);
      }
    }
    s && E();
  }, [a, s]), U(() => {
    u && (Ge(u), m(!0));
  }, [u]), U(() => {
    var D, Y;
    const E = () => {
      const S = window.location.href, A = l === "prod" ? "https://mityousee-odinapi.yousee.dk" : "https://yss-preprod-api.internal.yousee.dk";
      window.location.href = A + "/yousee/selfcare/profile/delegated-login-jwt?ReturnUrl=" + S;
    }, b = () => {
      const S = l === "prod" ? "https://login.yousee.dk" : "https://test.ciam.nuuday.dk";
      Ir(), window.location.href = S + "/idp/startSLO.ping?TargetResource=" + encodeURI("https://yousee.dk");
    };
    return v && (s != null && s.loggedIn ? (D = window.sharedNavigation) == null || D.addLogOutListener(b) : (Y = window.sharedNavigation) == null || Y.addLogInListener(E)), () => {
      var S, A;
      v && (s != null && s.loggedIn ? (S = window.sharedNavigation) == null || S.removeLogOutListener(b) : (A = window.sharedNavigation) == null || A.removeLogInListener(E));
    };
  }, [v, i, s, l]), /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
    u && /* @__PURE__ */ I.jsx(
      "div",
      {
        className: `ys-navigation ${t}`,
        ref: i,
        dangerouslySetInnerHTML: { __html: u }
      }
    ),
    g && /* @__PURE__ */ I.jsx("style", { children: `
        .nd-header__controls .nd-header__control:nth-child(2) {
          display: none;
        }
      ` })
  ] });
}, Yr = () => /* @__PURE__ */ I.jsx(Ar, {}), Fr = async () => new Promise((t) => {
  t();
});
export {
  Ur as Footer,
  Yr as Header,
  Ar as Navigation,
  Lr as fetchContent,
  Fr as fetchNavigationItems
};
